import { base64ToBlob } from "./Helpers";

export const getSenderEmailAddress = (callback) => {
  const item = Office.context.mailbox.item;

  // Check if the item is in read mode
  if (item.from && item.from.emailAddress) {
    const email = item.from.emailAddress;
    return callback(email);
  }

  // Check if the item is in compose mode
  if (item.from && typeof item.from.getAsync === "function") {
    // Compose mode get the recipient email
    Office.context.mailbox.item.to.getAsync((result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        // Get the first email address from the recipients
        if (result.value.length > 0) {
          const email = result.value[0].emailAddress;
          return callback(email);
        } else {
          console.error("No recipient email found");
          return callback(null);
        }
      } else {
        console.error("Failed to get recipient email:", result.error);
        return callback(null);
      }
    });
  } else {
    console.error("Unsupported item type");
    return callback(null);
  }
};

export const getMailboxAttachments = () => {
  const attachments = Office.context.mailbox.item.attachments;
  return attachments ? attachments : [];
};

export const isReadMode = () => {
  const item = Office.context.mailbox.item;

  return !!(item && item.from && item.from.emailAddress);
};

export const fetchAttachmentContent = async (attachmentId: string): Promise<{ content: string; format: string }> => {
  return new Promise((resolve, reject) => {
    Office.context.mailbox.item.getAttachmentContentAsync(attachmentId, (result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        resolve(result.value);
      } else {
        reject(result.error.message);
      }
    });
  });
};

export const createDocumentFromAttachment = async (attachmentId: string, attachments: any[]) => {
  if (!attachmentId) return null;

  try {
    const selectedAttachment = attachments.find((attachment) => attachment.id === attachmentId);
    const { content, format } = await fetchAttachmentContent(attachmentId);
    const blob = base64ToBlob(content, selectedAttachment.contentType);

    return {
      id: attachmentId,
      name: selectedAttachment.name,
      contentType: selectedAttachment.contentType,
      format: format,
      content: content,
      blob: blob,
    };
  } catch (error) {
    throw new Error("Failed to create document from attachment");
  }
};
